module.exports = __webpack_public_path__ + "media/images/hero-deco-left-38f79dc73360dd332b0833129ad5893a.svg";